<template>
  <MarketPage />
</template>

<script setup>
definePageMeta({ layout: 'default' })
</script>
